"use strict";

var core = require("../helpers/core");
var sessionStore = require("./storage").session;

var counterApiUrl = "https://classified-search.a.autoscout24.com/classified-search/totalcount?";
var classifiedSearchApiKey = "aG9tZTo1NGI2OWU1MDliZWMyODRkYjUxYmY3MGI1MmIxYzMwMQ==";

var lang = "en-GB";
var countryFormat = lang;

var doWithSearchForms = function(formDelegate) {
    [].forEach.call(document.querySelectorAll("form.search-form"), formDelegate);
};

var doWithFormInputs = function(form, inputDelegate) {
    [].forEach.call(form.querySelectorAll("input, select"), inputDelegate);
};

var isOfferTypeChecked = function(boxId) {
    var box = document.getElementById(boxId);
    return !box ? false : box.checked;
};

var setOfferTypeChecked = function(boxId, value) {
    var box = document.getElementById(boxId);
    if (box) {
        box.checked = value;
    }
};

var getStorageKey = function(dataType) {
    return "last_home_search_" + lang + "_" + dataType;
};

var updateModelSelect = function(modelSelect, modelsOrModelLines, modelValue) {
    var modelsOrModelLinesLength = modelsOrModelLines.length;

    for (var i = 0; i < modelsOrModelLinesLength; i++) {
        var modelOrModelLine = modelsOrModelLines[i];
        core.appendOption(modelSelect, modelOrModelLine.id, modelOrModelLine.name);

        if (typeof modelOrModelLine.models === "undefined") {
            continue;
        }

        var modelsOfModelLine = modelOrModelLine.models;

        for (var j = 0; j < modelsOfModelLine.length; j++) {
            var modelOfModelLine = modelsOfModelLine[j];
            core.appendOption(modelSelect, modelOfModelLine.id, "&nbsp;&nbsp;" + modelOfModelLine.name);
        }
    }

    modelSelect.disabled = modelsOrModelLinesLength === 0;
    modelSelect.value = modelValue ? modelValue : "0";
};

function getDefaultRadius(radiusSelect, postalCodeInput) {
    return (
        radiusSelect ? radiusSelect.getAttribute("data-default-value") :
        postalCodeInput ? postalCodeInput.getAttribute("data-default-radius") :
        undefined
    ) || "200";
}

var cleanCountryWhenZipIsPresented = function(queryString, hiddenCountryFlag) {
    var re = /cy=([FLB])/gi;  // we should apply this logic only for BE, LU , FR
    if (queryString.search(re) > 0){
        var countryFlag = re.exec(queryString)[1];
        if (hiddenCountryFlag === countryFlag && queryString.indexOf("zip=") > 0) {
            // we need to remove leading or trailing '&', that's why cascading replaces are done
            queryString = queryString.replace(/&cy=\D?/gi, "").replace(/cy=\D?&/gi, "").replace(/cy=\D?/gi, "");
        }
    }
    return queryString;
};

var bindEvents = function(dataTypePrefix) {
    var makeSelect = document.getElementById("home-" + dataTypePrefix + "-make");
    var numberOfMakesInput = document.getElementById("home-" + dataTypePrefix + "-make-count");
    var modelSelect = document.getElementById("home-" + dataTypePrefix + "-model");
    var firstRegistrationSelect = document.getElementById("home-" + dataTypePrefix + "-first-registration");
    var priceToSelect = document.getElementById("home-" + dataTypePrefix + "-price");
    var postalCodeInput = document.getElementById("home-" + dataTypePrefix + "-zip");
    var searchButton = document.getElementById("home-" + dataTypePrefix + "-button");
    var searchForm = document.getElementById("search-" + dataTypePrefix + "-form");
    var actionUrl = searchForm.getAttribute("data-action");
    if (actionUrl.indexOf("https") > -1){
        searchForm.setAttribute("action", actionUrl);
    }
    else{
        searchForm.setAttribute("action", actionUrl.replace("http", "https"));
    }
    var countrySelect = document.getElementById("home-" + dataTypePrefix + "-country");
    var hiddenCountry = document.getElementById("search-" + dataTypePrefix + "-form").querySelector("input[type='hidden'][name='cy']");

    // For zip auto-suggest
    var geoLat = document.getElementById("home-" + dataTypePrefix + "-lat");
    var geoLon = document.getElementById("home-" + dataTypePrefix + "-lon");
    var radiusSelect = document.getElementById("home-" + dataTypePrefix + "-zipr");
    var defaultRadius = getDefaultRadius(radiusSelect, postalCodeInput);

    var getModelType = function() {
        return makeSelect.getAttribute("data-type");
    };

    var getSelectedValueOrFalseIfDefault = function(select, defaultValueWhenUndefined) {
        return function() {
            return (
                select ? (
                    select.selectedIndex !== 0 ?
                        select.options[select.selectedIndex].value :
                        false
                ) : defaultValueWhenUndefined
            );
        };
    };

    var getValueOrDefault = function(textInput, defaultValue) {
        return function() {
            return (
                textInput ?
                    (textInput.value || defaultValue) :
                    defaultValue
            );
        };
    };

    var getSelectedMakeId = getSelectedValueOrFalseIfDefault(makeSelect);
    var getSelectedModelId = getSelectedValueOrFalseIfDefault(modelSelect);
    var getSelectedFirstRegistrationYear = getSelectedValueOrFalseIfDefault(firstRegistrationSelect);
    var getSelectedPriceTo = getSelectedValueOrFalseIfDefault(priceToSelect, 0);
    var getPostalCode = getValueOrDefault(postalCodeInput, "");
    var getCountry = getSelectedValueOrFalseIfDefault(countrySelect);
    var getSearchCountry = function() {
        var selectedCountry = getCountry();
        if(!selectedCountry && hiddenCountry) {
            return hiddenCountry.value;
        }
        return selectedCountry;
    };
    var getSelectedRadius = getSelectedValueOrFalseIfDefault(radiusSelect);

    var getOfferType = function() {
        var selectedOfferTypes = document.querySelectorAll(".offertype-selection-" + dataTypePrefix + " input[type=checkbox]:checked");
        var noOfCheckboxes = 3;
        if (lang.toLowerCase() === "nl-nl"){
            noOfCheckboxes = 2;
        }
        if (selectedOfferTypes && selectedOfferTypes.length > 0 && selectedOfferTypes.length < noOfCheckboxes){
            var offerTypes = [];
            for(var i = 0; i < selectedOfferTypes.length; i++) {
                offerTypes.push(selectedOfferTypes[i].value);
            }

            return offerTypes.join(",");
        }
        return "";
    };

    var resetModelList = function() {
        var modelText = modelSelect.options[0].text;
        modelSelect.innerHTML = "";
        modelSelect.disabled = true;
        core.appendOption(modelSelect, "0", modelText);
        modelSelect.value = "0";
    };

    var enableModelList = function() {
        modelSelect.disabled = false;
    };

    var fetchModelList = function(makeId, modelType, onSuccess) {
        var url = "/home/makes/" + makeId + "/models?modelType=" + modelType + "&lang=" + lang;
        core.ajax(url, "GET", onSuccess, "text/plain", false);
    };


  function isFormUnchanged() {
    return (
      getSelectedMakeId() === false &&
      getSelectedModelId() === false &&
      getSelectedFirstRegistrationYear() === false &&
      getPostalCode() === "" &&
      getOfferType() === "" &&
      getSelectedPriceTo() === false
    );
  }

  /**
   * only sort by age if form has no changes, feature is toggled
   * see https://jira.scout24.com/browse/AS24-21831
   * see https://jira.scout24.com/browse/AS24-23411
   * @param queryParams
   * @returns {boolean}
   */
    function shouldSortByAge(queryParams) {
      var tatsuCountries = ["A", "D", "I", "NL"];
      return (tatsuCountries.indexOf(queryParams.cy) >= 0 &&
        queryParams.atype === "C" &&
        isFormUnchanged()
      );
    }


    var getCounterUrlQuery = function(setCountry) {
        var offerType = getOfferType();
        var queryParams = {
            "atype": getModelType() || "C",
            "mmvmk0": getSelectedMakeId(),
            "mmvmd0": getSelectedModelId(),
            "fregfrom": getSelectedFirstRegistrationYear(),
            "zip": encodeURIComponent(getPostalCode().trim()),
            "priceto": getSelectedPriceTo(),
            "offer": offerType ? encodeURIComponent(offerType) : undefined,
            "cy": setCountry ? (setCountry === true ? getSearchCountry() : getCountry()) : undefined,
            "ustate": "N%2CU",
            "ipc": "home%3Asearchbox",
            "ipl": "button",
            "zipr": defaultRadius,
            "zipc": setCountry ? (setCountry === true ? getSearchCountry() : getCountry()) : undefined
        };

        if (shouldSortByAge(queryParams)) {
          queryParams.sort = "age";
          queryParams.desc = "1";
        }

        if (numberOfMakesInput && !numberOfMakesInput.disabled) {
            queryParams.mmvco = numberOfMakesInput.value;
        }

        if (geoLat && geoLat.value && geoLon && geoLon.value) {
            queryParams.lat = geoLat.value;
            queryParams.lon = geoLon.value;
        }
        if (radiusSelect) {
            queryParams.zipr = getSelectedRadius();
        }

        return Object.keys(queryParams).map(function(paramName) {
            return (
                queryParams[paramName] ?
                    paramName + "=" + queryParams[paramName] :
                    undefined
            );
        }).filter(function(paramValue) { return paramValue; }).join("&");
    };

    var updateLocalStorage = function(){
        var getMakeModelReg = function() {
            var selectedMake = getSelectedMakeId();
            var selectedModel = getSelectedModelId();
            var selectedFirstReg = getSelectedFirstRegistrationYear();
            var priceTo = getSelectedPriceTo();
            var postalCode = getPostalCode();
            var country = countrySelect ? getCountry() : undefined;

            var valuesToStore = {
                makeValue: selectedMake ? selectedMake : "0",
                modelValue: selectedModel ? selectedModel : "0",
                firstRegValue: selectedFirstReg ? selectedFirstReg : "0",
                priceToValue: priceTo ? priceTo : "0",
                postalCode: postalCode,
                country: country
            };

            if (geoLat && geoLat.value && geoLon && geoLon.value) {
                valuesToStore.lat = geoLat.value;
                valuesToStore.lon = geoLon.value;
            }
            if (radiusSelect) {
                valuesToStore.zipr = getSelectedRadius();
            }

            if (document.querySelector(".offertype-selection-" + dataTypePrefix)) {
                var cbNew = isOfferTypeChecked("cb-new-" + dataTypePrefix);
                var cbUsed = isOfferTypeChecked("cb-used-" + dataTypePrefix);
                var cbPreregistered = isOfferTypeChecked("cb-preregistered-" + dataTypePrefix);

                valuesToStore.cbNewValue = cbNew === false ? false : undefined;
                valuesToStore.cbUsedValue = cbUsed === false ? false : undefined;
                valuesToStore.cbPreregisteredValue = cbPreregistered === false ? false : undefined;
            }

            return valuesToStore;
        };

        sessionStore.set(getStorageKey(makeSelect.getAttribute("data-type")), getMakeModelReg());
    };

    var initCounter = function() {
        var onSuccess = function(data) {
            var count = data.tc;
            if (typeof count === "undefined") {
                return false;
            }
            searchButton.disabled = count.toString() === "0";
            searchButton.querySelector(".counter-container").innerHTML = core.formatCountNumber(count, countryFormat);
            searchButton.querySelector(".counter-successful").classList.remove("hidden");
            searchButton.querySelector(".counter-fallback").classList.add("hidden");
        };

        var onError = function() {
            searchButton.disabled = false;
            searchButton.querySelector(".counter-successful").classList.add("hidden");
            searchButton.querySelector(".counter-fallback").classList.remove("hidden");
        };

        var url = counterApiUrl + getCounterUrlQuery(countrySelect);

        url = cleanCountryWhenZipIsPresented(url, hiddenCountry.value);

        updateLocalStorage();
        var offerType = document.getElementById("offer-" + dataTypePrefix);
        if (offerType){
            offerType.value = getOfferType();
        }

        core.ajax(url, "GET", onSuccess, "text/plain", true, onError, { "Authorization": "Basic " + classifiedSearchApiKey });
    };

    var onMakeSelectChange = function() {

        var selectedIndex = this.selectedIndex;

        if (numberOfMakesInput) {
            numberOfMakesInput.disabled = selectedIndex === 0;
        }

        if (selectedIndex === 0) {
            resetModelList();
            initCounter();
            return false;
        }

        var onSuccess = function(modelsOrModelLines) {
            resetModelList();
            updateModelSelect(modelSelect, modelsOrModelLines);
            initCounter();
            enableModelList();
        };

        var makeId = this.options[selectedIndex].value;
        var modelType = getModelType();

        fetchModelList(makeId, modelType, onSuccess);
    };

    var onCountrySelectChange = function(){
        postalCodeInput.value = "";
        geoLat.value = "";
        geoLon.value = "";
        if (radiusSelect) {
            radiusSelect.value = "0";
            radiusSelect.disabled = true;
        }
        initCounter();
        return false;
    };

    var onPriceSelectChange = function() {
        initCounter();
        return false;
    };

    var disableEmptyInputs = function(form) {
        var deviceAgent = navigator.userAgent.toLowerCase();
        if (!/(iphone|ipod|ipad).* os 9_/.test(deviceAgent)) {
            var defaultValuePerNodeName = { "input": "", "select": "0" };
            doWithFormInputs(form, function(input) {
                input.disabled = input.value === defaultValuePerNodeName[input.nodeName.toLowerCase()];
            });
        }
    };

    var onCounterUpdateRequested = function(){
        initCounter();
    };

    document.addEventListener("counterUpdateRequested", onCounterUpdateRequested);

    core.addEvent(makeSelect, "change", onMakeSelectChange);
    if (priceToSelect){
        core.addEvent(priceToSelect, "change", onPriceSelectChange);
    }
    core.addEvent(modelSelect, "change", initCounter);
    core.addEvent(firstRegistrationSelect, "change", initCounter);
    if (countrySelect) {
        core.addEvent(countrySelect, "change", onCountrySelectChange);
    }
    if (radiusSelect) {
        core.addEvent(radiusSelect, "change", function() {
            initCounter();
            return false;
        });
    }
    if (postalCodeInput) {
        core.addEvent(postalCodeInput, "keyup", initCounter);
        core.addEvent(postalCodeInput, "change", initCounter);
    }
    core.addEventBySelector(".offertype-selection-" + dataTypePrefix + " input[type=checkbox]", "change", initCounter);
    doWithSearchForms(function(form) {
        core.addEvent(form, "submit", function() { disableEmptyInputs(form); });
    });

    /* disable submit & add click event*/
    core.addEvent(searchForm, "submit", function(ev) { ev.preventDefault(); });

    core.addEvent(searchButton, "click", function(event) {
        var url = getCounterUrlQuery(true);
        if (searchForm.action.indexOf("?") > -1) {
            url = "&" + url;
        }
        else {
            url = "?" + url;
        }

        url = cleanCountryWhenZipIsPresented(url, hiddenCountry.value);

        event.preventDefault();
        document.location = searchForm.getAttribute("data-action") + url;
    });

    function isLastSearchInStorage() {
      return sessionStore.get(getStorageKey(makeSelect.getAttribute("data-type"))) || false;
    }

    if (isLastSearchInStorage()) {
      initCounter();
    }

};

var initSearchMask = function(dataTypePrefix){
    var makeSelect = document.getElementById("home-" + dataTypePrefix + "-make");
    var numberOfMakesInput = document.getElementById("home-" + dataTypePrefix + "-make-count");
    var modelSelect = document.getElementById("home-" + dataTypePrefix + "-model");
    var firstRegistrationSelect = document.getElementById("home-" + dataTypePrefix + "-first-registration");
    var priceToSelect = document.getElementById("home-" + dataTypePrefix + "-price");
    var postalCodeInput = document.getElementById("home-" + dataTypePrefix + "-zip");
    var countrySelect = document.getElementById("search-" + dataTypePrefix + "-form").querySelector("select[name='cy']");
    var radiusSelect = document.getElementById("home-" + dataTypePrefix + "-zipr");
    var lastSearch = sessionStore.get(getStorageKey(makeSelect.getAttribute("data-type"))) || {};
    var defaultRadius = getDefaultRadius(radiusSelect, postalCodeInput);

    if (document.querySelector(".offertype-selection-" + dataTypePrefix)) {
        setOfferTypeChecked("cb-new-" + dataTypePrefix, lastSearch.cbNewValue !== undefined ? lastSearch.cbNewValue : true);
        setOfferTypeChecked("cb-used-" + dataTypePrefix, lastSearch.cbUsedValue !== undefined ? lastSearch.cbUsedValue : true);
        setOfferTypeChecked("cb-preregistered-" + dataTypePrefix, lastSearch.cbPreregisteredValue !== undefined ? lastSearch.cbPreregisteredValue : true);
    }

    firstRegistrationSelect.value = lastSearch.firstRegValue ? lastSearch.firstRegValue : "0";

    makeSelect.value = lastSearch.makeValue ? lastSearch.makeValue : "0";
    if (priceToSelect){
        priceToSelect.value = lastSearch.priceToValue ? lastSearch.priceToValue : "0";
    }
    if (postalCodeInput && lastSearch.postalCode) {
        postalCodeInput.value = lastSearch.postalCode;
    }
    if (countrySelect) {
        if(lastSearch.country){
            countrySelect.value = lastSearch.country;
        }
    }

    var geoLat = document.getElementById("home-" + dataTypePrefix + "-lat");
    var geoLon = document.getElementById("home-" + dataTypePrefix + "-lon");
    if (geoLat && lastSearch.lat && geoLon && lastSearch.lon) {
        geoLat.value = lastSearch.lat;
        geoLon.value = lastSearch.lon;
        if (radiusSelect && lastSearch.postalCode) {
            radiusSelect.disabled = false;
            radiusSelect.value = lastSearch.zipr || defaultRadius;
        }
    }

    if (numberOfMakesInput) {
        numberOfMakesInput.disabled = makeSelect.value === "0";
    }

    if(makeSelect.value !== "0"){
        var url = "/home/makes/" + makeSelect.value + "/models?modelType=" + makeSelect.getAttribute("data-type") + "&lang=" + lang;
        core.ajax(url, "GET", function(modelsOrModelLines){
            updateModelSelect(modelSelect, modelsOrModelLines, lastSearch.modelValue);
            bindEvents(dataTypePrefix);
        }, "text/plain", false);
    }
    else{
        bindEvents(dataTypePrefix);
    }
};

var initDetailSearchLink = function (dataType) {
    var serializeForm = function (searchForm) {
        var serializeCriterion = function(criterion) {
            return (
                criterion.value && criterion.value !== "0" ?
                    criterion.name + "=" + encodeURIComponent(criterion.value.trim()) :
                    ""
            );
        };
        return Array.prototype.map.call(searchForm.querySelectorAll("select, input[type=\"text\"], input[name=\"lat\"], input[name=\"lon\"], input[name=\"offer\"]"), serializeCriterion)
            .filter(function(paramAndValue) { return paramAndValue; })
            .concat("atype=" + (dataType === "car" ? "C" : "B"))
            .join("&");
    };
    var link = document.querySelector("a[id=\"refine-search-" + dataType + "s\"]");
    var searchForm = document.getElementById("search-" + dataType + "-form");
    var hiddenCountry = document.getElementById("search-" + dataType + "-form").querySelector("input[type='hidden'][name='cy']");
    core.addEvent(link, "click", function(e) {
        var queryParams = serializeForm(searchForm);
        if(queryParams.indexOf("cy=") < 0){
            queryParams += hiddenCountry ? "&cy=" + hiddenCountry.value : "";
        }
        queryParams = cleanCountryWhenZipIsPresented(queryParams, hiddenCountry.value);
        document.location = link.href.split("?")[0] + "?" + queryParams;
        e.preventDefault();
    });
};

var initLogoutMessage = function() {
  var logoutMessage = document.getElementById("logout-msg");
  if(logoutMessage) {
    logoutMessage.className += " show";
      window.setTimeout(function() { logoutMessage.className = logoutMessage.className.replace(" show", ""); }, 5000);
  }
};

var init = function() {
    // HACK FOR IOS 8 removing option group from make select.
    var deviceAgent = navigator.userAgent.toLowerCase();
    if (/(iphone|ipod|ipad).* os 8_/.test(deviceAgent)) {
        var makeSelects = document.querySelectorAll("[name='make']");
        for (var i = 0; i < makeSelects.length; i++) {
            var makeSelect = makeSelects[i];
            var optgroup = makeSelect.querySelector("optgroup");
            if (optgroup) {
                var makeValue = makeSelect.value;
                makeSelect.removeChild(optgroup);
                makeSelect.innerHTML += optgroup.innerHTML;
                makeSelect.value = makeValue;
            }
        }
    }

    var langElement = document.getElementById("home-search-lang");
    lang = countryFormat = langElement !== null ? langElement.getAttribute("data-lang") : countryFormat;
    if (document.getElementById("search-car-form")) {
        initSearchMask("car");
        initDetailSearchLink("car");
    }
    if (document.getElementById("search-moto-form")) {
        initSearchMask("moto");
        initDetailSearchLink("moto");
    }
    initLogoutMessage();
};

module.exports = {
    init: init
};
